/* SEVEN ÁNGEL – Produktseiten-Blöcke für Dawn */
(function () {
  if (window.__saBlocks) return;
  window.__saBlocks = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function readJSON(el) {
    var s = el.querySelector('script[type="application/json"]');
    try { return s ? JSON.parse(s.textContent) : []; } catch (e) { return []; }
  }
  function findVariant(list, id) {
    for (var i = 0; i < list.length; i++) if (String(list[i].id) === String(id)) return list[i];
    return null;
  }

  /* ── Variantenwechsel erkennen (funktioniert mit allen Dawn-Versionen) ── */
  function currentVariantId(sectionId, fallback) {
    var form = document.getElementById('product-form-' + sectionId);
    var input = form && form.querySelector('input[name="id"]');
    if (input && input.value) return String(input.value);
    return String(new URLSearchParams(location.search).get('variant') || fallback || '');
  }
  var watchers = [];
  function onVariantChange(sectionId, initial, cb) { watchers.push({ sid: sectionId, last: String(initial), cb: cb }); }
  function checkVariants() {
    watchers.forEach(function (w) {
      var id = currentVariantId(w.sid, w.last);
      if (id && id !== w.last) { w.last = id; w.cb(id); }
    });
  }
  setInterval(checkVariants, 400);
  document.addEventListener('change', function () { setTimeout(checkVariants, 60); });

  /* ── In den Warenkorb (für Upsell) ── */
  function cartAdd(items) {
    var cart = document.querySelector('cart-drawer');
    var body = { items: items };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Fehler');
        if (cart && typeof cart.renderContents === 'function') {
          cart.classList.remove('is-empty');
          cart.renderContents(data);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || root + 'cart';
        }
        return data;
      });
    });
  }

  /* ── Addons: beim Klick auf "In den Warenkorb" mit hinzufügen ── */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.id || form.dataset.saAddonsPass === '1') return;
    var blocks = document.querySelectorAll('[data-sa="addons"][data-form="' + form.id + '"]');
    if (!blocks.length) return;
    var items = [];
    blocks.forEach(function (b) {
      b.querySelectorAll('[data-sa-addon]:checked').forEach(function (cb) {
        var row = cb.closest('.sa-addon');
        var sel = row && row.querySelector('[data-sa-addon-variant]');
        items.push({ id: Number(sel ? sel.value : cb.value), quantity: 1 });
      });
    });
    if (!items.length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('loading');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).catch(function () {}).then(function () {
      form.dataset.saAddonsPass = '1';
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      delete form.dataset.saAddonsPass;
    });
  }, true);

  /* ── Einzelne Blöcke ── */
  function initTabs(el) {
    var tabs = [].slice.call(el.querySelectorAll('[role="tab"]'));
    var panels = [].slice.call(el.querySelectorAll('[role="tabpanel"]'));
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x, j) {
          x.setAttribute('aria-selected', i === j ? 'true' : 'false');
          x.tabIndex = i === j ? 0 : -1;
          if (panels[j]) panels[j].hidden = i !== j;
        });
      });
    });
  }

  function initAtcPrice(el) {
    var sid = el.dataset.section, variants = readJSON(el);
    var showPrice = el.dataset.price === 'true', showCompare = el.dataset.compare === 'true', arrow = el.dataset.arrow === 'true';
    var customText = (el.dataset.text || '').trim();
    var id = currentVariantId(sid, el.dataset.variant);
    function span() {
      var f = document.getElementById('product-form-' + sid);
      return f && f.querySelector('.product-form__submit > span');
    }
    function add() {
      var sp = span(); if (!sp) return;
      var v = findVariant(variants, id);
      if (v && !v.available) return;
      if (customText) {
        var tn = null;
        for (var i = 0; i < sp.childNodes.length; i++) { var n = sp.childNodes[i]; if (n.nodeType === 3 && n.textContent.trim()) { tn = n; break; } }
        if (!tn) { tn = document.createTextNode(''); sp.appendChild(tn); }
        if (tn.textContent.trim() !== customText) tn.textContent = customText;
      }
      if (sp.querySelector('.sa-atc-extra')) return;
      if (arrow) sp.insertAdjacentHTML('afterbegin', '<span class="sa-atc-extra sa-atc-arrow" aria-hidden="true">→</span>');
      if (showPrice && v) sp.insertAdjacentHTML('beforeend', '<span class="sa-atc-extra sa-atc-price"> – ' + v.price + (showCompare && v.compare ? ' <s>' + v.compare + '</s>' : '') + '</span>');
    }
    function refresh() {
      var sp = span(); if (sp) sp.querySelectorAll('.sa-atc-extra').forEach(function (n) { n.remove(); });
      add();
    }
    refresh();
    var form = document.getElementById('product-form-' + sid);
    if (form) new MutationObserver(function () { add(); }).observe(form, { childList: true, subtree: true, characterData: true });
    onVariantChange(sid, id, function (newId) { id = newId; refresh(); });
  }

  function initVideos(el) {
    var dlg = el.querySelector('dialog'), body = el.querySelector('[data-sa-modal-body]');
    function close() { body.innerHTML = ''; if (dlg.open) { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); } }
    el.querySelectorAll('.sa-videos__item').forEach(function (item) {
      item.addEventListener('click', function () {
        var src = item.querySelector('video'); if (!src) return;
        var v = src.cloneNode(true);
        v.removeAttribute('muted'); v.muted = false; v.controls = true; v.loop = false;
        body.innerHTML = ''; body.appendChild(v);
        if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      });
    });
    el.querySelector('.sa-videos__close').addEventListener('click', close);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.addEventListener('close', function () { body.innerHTML = ''; });
  }

  function initSticky(el) {
    var sid = el.dataset.section, variants = readJSON(el);
    document.querySelectorAll('body > .sa-sticky[data-section="' + sid + '"]').forEach(function (old) { if (old !== el) old.remove(); });
    if (el.parentElement !== document.body) document.body.appendChild(el);
    var btn = el.querySelector('[data-sa-sticky-btn]');
    function mainBtn() { var f = document.getElementById('product-form-' + sid); return f && f.querySelector('[type="submit"]'); }
    btn.addEventListener('click', function () {
      var m = mainBtn(); if (!m) return;
      if (m.disabled || m.getAttribute('aria-disabled') === 'true') { m.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      m.click();
    });
    var target = document.getElementById('product-form-' + sid) || document.getElementById('MainProduct-' + sid);
    if (target && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        el.classList.toggle('is-visible', show);
        el.setAttribute('aria-hidden', show ? 'false' : 'true');
      }).observe(target);
    }
    function render(id) {
      var v = findVariant(variants, id); if (!v) return;
      el.querySelector('[data-sa-sticky-price]').innerHTML = v.price + (v.compare ? ' <s>' + v.compare + '</s>' : '');
      var vt = el.querySelector('[data-sa-sticky-variant]');
      if (vt && variants.length > 1) vt.textContent = v.title + ' · ';
      btn.disabled = !v.available;
      btn.textContent = v.available ? el.dataset.textAdd : el.dataset.textSold;
    }
    var init = currentVariantId(sid, el.dataset.variant);
    render(init);
    onVariantChange(sid, init, render);
  }

  function initShipping(el) {
    var days = parseInt(el.dataset.days || '1', 10);
    var cutoff = parseInt(el.dataset.cutoff || '14', 10);
    var skip = el.dataset.weekends === 'true';
    var now = new Date(), d = new Date();
    function weekend(x) { return x.getDay() === 0 || x.getDay() === 6; }
    if (d.getHours() >= cutoff) d.setDate(d.getDate() + 1);
    if (skip) while (weekend(d)) d.setDate(d.getDate() + 1);
    var added = 0;
    while (added < days) { d.setDate(d.getDate() + 1); if (!skip || !weekend(d)) added++; }
    var out = el.querySelector('[data-sa-date]');
    if (d.toDateString() === now.toDateString() && el.dataset.today) { out.textContent = el.dataset.today; return; }
    var lang = document.documentElement.lang || 'de';
    out.textContent = d.toLocaleDateString(lang, { weekday: 'short', day: 'numeric', month: 'short' });
  }

  function initPulse(el) {
    var sid = el.dataset.section, variants = readJSON(el), low = parseInt(el.dataset.low || '5', 10);
    var text = el.querySelector('.sa-pulse__text');
    function render(id) {
      if (el.dataset.mode === 'custom') { el.dataset.state = 'in'; return; }
      var v = findVariant(variants, id); if (!v) return;
      var state = 'in', t = el.dataset.tIn;
      if (!v.available) { state = 'out'; t = el.dataset.tOut; }
      else if (v.tracked && v.policy === 'deny' && v.qty > 0 && v.qty <= low) { state = 'low'; t = (el.dataset.tLow || '').replace('[count]', v.qty); }
      el.dataset.state = state;
      text.textContent = t;
    }
    var init = currentVariantId(sid, el.dataset.variant);
    render(init);
    onVariantChange(sid, init, render);
  }

  function initCountdown(el) {
    var raw = (el.dataset.end || '').trim().replace(' ', 'T');
    var end = new Date(raw).getTime();
    if (!raw || isNaN(end)) { el.hidden = true; return; }
    var total = Math.max(1, parseFloat(el.dataset.barHours || '24') * 3600000);
    var timeEl = el.querySelector('[data-sa-time]'), bar = el.querySelector('[data-sa-bar]');
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    var timer;
    function tick() {
      var left = end - Date.now();
      if (left <= 0) {
        clearInterval(timer);
        timeEl.textContent = '00:00:00'; bar.style.width = '0%';
        if (el.dataset.hide === 'true') el.hidden = true;
        return;
      }
      var s = Math.floor(left / 1000), d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      timeEl.textContent = (d ? d + (el.dataset.dayLabel || 'T') + ' ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
      bar.style.width = Math.min(100, (left / total) * 100) + '%';
    }
    timer = setInterval(tick, 1000);
    tick();
  }

  function initCoupon(el) {
    var b = el.querySelector('.sa-coupon__btn'), label = b.querySelector('span'), orig = label.textContent;
    b.addEventListener('click', function () {
      var code = b.dataset.code;
      function done() { label.textContent = b.dataset.copied; setTimeout(function () { label.textContent = orig; }, 2000); }
      function fallback() {
        var ta = document.createElement('textarea'); ta.value = code; document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); } catch (e) {}
        ta.remove(); done();
      }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, fallback);
      else fallback();
    });
  }

  function initCarousel(el) {
    var track = el.querySelector('[data-sa-track]');
    var btns = el.querySelectorAll('[data-dir]');
    if (track.children.length < 2) { btns.forEach(function (b) { b.hidden = true; }); return; }
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var dir = parseInt(b.dataset.dir, 10);
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        var atStart = track.scrollLeft <= 4;
        if (dir > 0 && atEnd) track.scrollTo({ left: 0, behavior: 'smooth' });
        else if (dir < 0 && atStart) track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
        else track.scrollBy({ left: track.clientWidth * dir, behavior: 'smooth' });
      });
    });
  }

  function initUpsell(el) {
    el.querySelectorAll('[data-sa-upsell-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var row = btn.closest('.sa-upsell__item'), sel = row.querySelector('select');
        var id = Number(sel ? sel.value : btn.dataset.variant), orig = btn.innerHTML;
        btn.disabled = true;
        cartAdd([{ id: id, quantity: 1 }]).then(function () {
          btn.innerHTML = el.dataset.added || '✓';
        }).catch(function () {
          btn.innerHTML = 'Nicht verfügbar';
        }).then(function () {
          setTimeout(function () { btn.innerHTML = orig; btn.disabled = false; }, 2200);
        });
      });
    });
  }

  var inits = {
    tabs: initTabs, 'atc-price': initAtcPrice, videos: initVideos, sticky: initSticky,
    shipping: initShipping, pulse: initPulse, countdown: initCountdown, coupon: initCoupon,
    carousel: initCarousel, upsell: initUpsell
  };
  function initAll(scope) {
    (scope || document).querySelectorAll('[data-sa]').forEach(function (el) {
      if (el.dataset.saReady) return;
      var fn = inits[el.dataset.sa];
      if (!fn) return;
      el.dataset.saReady = '1';
      try { fn(el); } catch (err) { console.warn('[SEVEN ÁNGEL Blocks]', err); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();